import React, {Component} from 'react';
import {
    Grid,
    Typography
} from 'material-ui';
import {
    Field,
    reduxForm
} from 'redux-form';
import {InputTextField} from '../../../components/fields/field_input_text';
import {InputHiddenField} from '../../../components/fields/field_input_hidden';
import {SimpleEditorField} from '../../../components/fields/field_simple_editor';
import {BackButton} from '../../../components/buttons/BackButton';
import {SaveButton} from '../../../components/buttons/SaveButton';
import {removeBlankParagraphs} from '../../../components/helpers/helpers';

class StaffTranslationEditForm extends Component {

    render() {

        const {
            staffMember,
            classes,
            handleSubmit,
            pristine,
            siteName,
            loading,
            touched
        } = this.props;

        return (
                <Grid container>
                    <Grid item xs={12} md={6}>
                        <div className="heading">
                            <p className="lead">Initial content for Staff: <em>"{staffMember.name + ' ' + staffMember.firstname}"</em></p>
                        </div>
                        <Field
                            className={classes.inputFormField}
                            name="initialName"
                            component={InputTextField}
                            label={staffMember.name}
                            fullWidth
                            disabled
                        />
                        <Field
                            className={classes.inputFormField}
                            name="initialFirstname"
                            component={InputTextField}
                            label={staffMember.firstname}
                            fullWidth
                            disabled
                        />
                        <Typography
                            variant="subheading"
                            style={{color: '#a5a5a5' }}
                            dangerouslySetInnerHTML={{__html: removeBlankParagraphs(staffMember.description)}}
                            className="pbSectionEditorText"
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <div className="heading">
                            <p className="lead">Translation for {siteName}</p>
                        </div>
                        <form onSubmit={handleSubmit(this.props.handleFormSubmit)}>
                            <Field name="translationId" type="hidden" component={InputHiddenField}/>
                            <Field name="staffId" type="hidden" component={InputHiddenField}/>
                            <Field
                                name="name"
                                component={InputTextField}
                                label="Translated Name"
                                fullWidth
                                autoFocus
                                InputStaffProps={{
                                    required: true,
                                }}
                            />
                            <Field
                                name="firstname"
                                component={InputTextField}
                                label="Translated Firstname"
                                fullWidth
                                InputStaffProps={{
                                    required: true,
                                }}
                            />
                            <Grid item>
                                <Field
                                    name="description"
                                    component={SimpleEditorField}
                                    label="Translated Description"
                                />
                            </Grid>
                            <Grid container className={classes.staffRows}>
                                <Grid item xs={12}>
                                    <SaveButton
                                        type="submit"
                                        loading={loading}
                                        disabled={(!touched && pristine) || loading}
                                        variant="raised"
                                        color="primary"
                                        className="floatRight"
                                    />
                                    <BackButton
                                        link={"/staff/" + staffMember.id + "/translations"}
                                        style={{marginRight: 15 }}
                                        variant="raised"
                                        className="floatRight"
                                    />
                                </Grid>
                            </Grid>
                        </form>
                    </Grid>
                </Grid>
            )
        }
    }

export default reduxForm({
    form: 'StaffTranslationEditForm',
    enableReinitialize: true,
    destroyOnUnmount: false,
})(StaffTranslationEditForm);


// WEBPACK FOOTER //
// ./src/containers/staff/forms/StaffTranslationEditForm.jsx